export default "__VITE_ASSET__BdsxOYJV__"